import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';


export const accordionOverrideStyles = makeStyles((theme) => ({
    accordionContainer: {
        '&.border-bottom': {
            borderBottom: `1px solid ${tcsmColors.greyFive}`,
            marginBottom: theme.spacing(1),
        },
        '& .MuiButtonBase-root': {
            '&:focus:not(:focus-visible)': {
                outlineColor: 'transparent',
                boxShadow: 'none',
            },
        },
        '& .MuiAccordion-root': {
            boxShadow: 'none',
            borderTop: `1px solid ${tcsmColors.greyFive}`,
            '&-header': {
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: theme.spacing(1),
            },
            '&.Mui-expanded': {
                margin: '0',
            },
            '& .MuiAccordionSummary': {
                '&-root': {
                    padding: theme.spacing(.5),
                    position: 'relative',
                    '& > div': {
                        margin: 0,
                        display: 'block',
                    },
                    '&-parent': {
                        color: tcsmColors.blue,
                        '& .MuiAccordionSummary-expandIcon': {
                            padding: '.375rem',
                            '& svg': {
                                height: '2.25rem',
                                width: '2.25rem',
                            },
                        },
                    },
                },


                '&-expandIcon': {
                    position: 'absolute', // Position trigger button due to limited html editing capabilities of MUI accordion
                    right: 0,
                    margin: 0,
                    top: 0,

                    '& svg': {
                        fill: tcsmColors.blue,
                    },
                },
            },
            '& .MuiAccordionDetails-root': {
                padding: theme.spacing(.5),
                width: '100%',
                display: 'block',
                '& [class*="labelRowContainer"]': {
                   
                    [theme.breakpoints.up('md')]: {
                        width: '75%',
                    },
                },
                '&-inner': {
                    width: '100%',
                },
            },
            '&-details': {
                padding: '0rem 1rem 1rem 1rem',
                display: 'block',
               
            },
            '&-subheader': {
                marginBottom: theme.spacing(.5),

                [theme.breakpoints.down('sm')]: {
                    marginBottom: theme.spacing(.25),
                },
                '&-expanded': {
                    marginTop: theme.spacing(.5),

                    [theme.breakpoints.down('sm')]: {
                        marginTop: theme.spacing(.25),
                    },
                },
            },

        },
    },

}));



